import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Loader2, Lock } from "lucide-react";
import { Input } from "../components/ui/input";
import { AuthLayout, Field, fieldCls } from "../components/auth/AuthLayout";
import { useAuth } from "../lib/auth";
import { formatApiError } from "../lib/api";

const homeFor = (user) => (user?.role === "admin" ? "/admin" : "/oficina");

export default function Login() {
  const { user, login } = useAuth();
  const nav = useNavigate();
  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user) nav(homeFor(user), { replace: true });
  }, [user, nav]);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const u = await login(phone, password);
      nav(homeFor(u), { replace: true });
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthLayout testId="login-page">
      <span className="grid h-14 w-14 place-items-center rounded-2xl bg-leaf text-ink"><Lock className="h-6 w-6" /></span>
      <h1 className="mt-8 font-display text-4xl font-semibold tracking-tight sm:text-5xl">Ingresar</h1>
      <p className="mt-3 text-base text-[#AEB7D3]">Accede a tu oficina virtual de distribuidor o al panel administrativo con tu celular y contraseña.</p>
      <form onSubmit={submit} className="mt-10 space-y-5" data-testid="login-form">
        <Field id="phone" label="Celular">
          <Input id="phone" type="tel" inputMode="numeric" required autoComplete="username" placeholder="10 dígitos" value={phone} onChange={(e) => setPhone(e.target.value)} className={fieldCls} data-testid="login-phone" />
        </Field>
        <Field id="password" label="Contraseña">
          <Input id="password" type="password" required autoComplete="current-password" value={password} onChange={(e) => setPassword(e.target.value)} className={fieldCls} data-testid="login-password" />
        </Field>
        {error && <p className="rounded-xl border border-coral/40 bg-coral/10 px-4 py-3 text-sm text-[#ffb3b5]" data-testid="login-error">{error}</p>}
        <button type="submit" disabled={loading} className="btn-leaf w-full disabled:opacity-60" data-testid="login-btn">
          {loading ? <Loader2 className="h-5 w-5 animate-spin" /> : "Entrar"}
        </button>
      </form>
      <p className="mt-8 text-sm text-[#AEB7D3]">
        ¿Aún no tienes cuenta?{" "}
        <Link to="/registro" className="font-semibold text-leaf underline-offset-4 hover:underline" data-testid="login-to-register">Regístrate como distribuidor</Link>
      </p>
    </AuthLayout>
  );
}
